import React, { useState } from 'react';
import { StyleSheet, Text, View } from 'react-native';
/**
 * [TODO] Deprecate in-favor of Popover (which supports <Hoverable> and a few other non-web devices)
 */
const styles = StyleSheet.create({
    toolTipText: {
        color: 'white',
        fontSize: 13,
    },
    toolTip: {
        marginTop: -6,
        backgroundColor: 'rgba(21, 26, 48, 0.88)',
        borderRadius: 4,
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 14,
        paddingRight: 14,
        position: 'absolute',
        width: 'max-content',
    },
});
function WebToolip(props) {
    const [isToolTipVisible, setIsToolTipVisible] = useState(false);
    function showTooltip() {
        setIsToolTipVisible(true);
    }
    function hideTooltip() {
        setIsToolTipVisible(false);
    }
    return (<div onMouseOver={showTooltip} onMouseLeave={hideTooltip}>
      {isToolTipVisible && (<View style={styles.toolTip}>
          <div onMouseOut={hideTooltip}>
            <Text style={styles.toolTipText}>{props.toolTipText}</Text>
          </div>
        </View>)}
      <div>{props.children}</div>
    </div>);
}
export default WebToolip;
//# sourceMappingURL=WebTooltip.web.js.map